import { render, staticRenderFns } from "./child-menu.vue?vue&type=template&id=6c9d77a5&"
import script from "./child-menu.vue?vue&type=script&lang=js&"
export * from "./child-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports